module.exports = __webpack_public_path__ + "static/media/banner-placeholder.38643de4.png";